import { Component, Input, OnInit } from '@angular/core';
import { AuthenticationService } from 'app/services/authentication.service';
import { LocationService } from 'app/services/location.service';

export interface SsoConfig {
	name: string;
	endpoint: string;
	type: string;
}

@Component({
	selector: 'login-user-sso',
	templateUrl: './login-user-sso.component.html',
	styleUrls: ['./login-user-sso.component.scss'],
})
export class LoginUserSsoComponent implements OnInit {
	@Input() ssoProviders: SsoConfig[];

	constructor(
		private authenticationService: AuthenticationService,
		private locationService: LocationService,
	) {
	}

	ngOnInit() { }

	ssoLogin(endpoint: string) {
		if (endpoint) {
			const lastVisitedUrl = this.authenticationService.lastVisitedUrl;

			if (lastVisitedUrl) {
				const urlParts = lastVisitedUrl.split('?');
				if (urlParts.length > 1) {
					const parameterList = urlParts[1].split('&');

					const parameters = parameterList.find((param) => param.startsWith('reacthash='));

					if (parameters) {
						const reactHashValue = parameters.split('=');
						if (reactHashValue.length > 1) {
							endpoint = endpoint.replace(/([&?]state=[^&]+)/, '$1:' + btoa('react=' + reactHashValue[1]));
						}
					}
				}
			} else if (this.locationService.host.startsWith('local.dev.bbvms.com') || this.locationService.host.startsWith('localhost')) {
				endpoint = endpoint.replace(/([&?]state=[^&]+)/, '$1:' + btoa(this.locationService.host));
			}
			window.location.href = endpoint;
		}
	}
}
